import SodSeverityChip from './SodSeverityChip';

export default SodSeverityChip;
